// item means email,letter,sms,page,form
export const itemSettings = {
    itemsWithDashedName:['page','form','letter'],// in which item 
    itemNameRegx:/[`~!@#$%^&*)(}{\][\?<>\|\\:;"',.+=/\s]/gi
}